declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

export interface AppConfig {
  apiBaseUrl: string;
  msal: {
    disabled: boolean;
    clientId: string;
    tenantId: string;
    apiScope: string;
  };
}

const defaults: AppConfig = {
  apiBaseUrl: "/api",
  msal: {
    disabled: true,
    clientId: "",
    tenantId: "",
    apiScope: "",
  },
};

export const appConfig: AppConfig = {
  ...defaults,
  ...(typeof window !== "undefined" ? window.__APP_CONFIG__ ?? {} : {}),
};
